import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Typography, MobileCardItem, InputSearch, ContainerSearch, MobileContainerAnimation, SwitchStatus, DialogAddChatUser, makeStyles, CanSwitch } from "../../../../";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      minHeight: "100%"
    },
    searchContainer: {
      display: "flex",
      flexFlow: "row nowrap",
      alignItems: "center",
      height: "60px",
      paddingTop: "8px",
      position: "fixed",
      width: "100%",
      zIndex: "10",
      background: theme.palette.background["default"]
    },
    content: {
      padding: "10px 8px 12px 8px",
      width: "100%"
    },
    search: {
      borderRadius: "60px",
      margin: "0"
    },
    defaultCard: {
      padding: "8px 4px"
    },
    my12: {
      margin: "12px 0"
    },
    inputSearch: {
      borderRadius: "10px",
      margin: "10px 0",
      "box-shadow": "none",
      fontSize: "0.8em"
    },
    addIcon: {
      display: "flex",
      "justify-content": "flex-end"
    }
  };
});

var MobileCampusDirectMessages = function MobileCampusDirectMessages(props) {
  // console.log("MobileCampusDirectMessages props", props);
  var data = props.data,
      translation = props.translation,
      handleDownloadInfo = props.handleDownloadInfo,
      role = props.role;
  var classes = useStyles();

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      openDialogAddUser = _useState4[0],
      setOpenDialogAddUser = _useState4[1];

  var _useState5 = useState(""),
      _useState6 = _slicedToArray(_useState5, 2),
      _users = _useState6[0],
      set_Users = _useState6[1];

  useEffect(function () {
    //TODO mejora->filter users si ya tienen direct_message
    data && data.users && set_Users(data.users.map(function (user) {
      return {
        label: user.name,
        value: user.rocket_chat.username
      };
    }));
  }, [data]);

  var handleSearchChange = function handleSearchChange(event) {
    setSearchValue(event.target.value);
  };

  var handleModalDialogAddUser = function handleModalDialogAddUser() {
    setOpenDialogAddUser(!openDialogAddUser);
  };

  return /*#__PURE__*/React.createElement(MobileContainerAnimation, Object.assign({
    classes: classes.root
  }, props.routerState || null), /*#__PURE__*/React.createElement(SwitchStatus, {
    status: props.status,
    action_download: function action_download() {
      handleDownloadInfo();
      return null;
    },
    success: function success() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CanSwitch, {
        role: role,
        coordinator: function coordinator() {
          return /*#__PURE__*/React.createElement(DialogAddChatUser, {
            open: openDialogAddUser,
            searchValue: searchValue,
            onClose: handleModalDialogAddUser,
            mobile: true,
            users: _users,
            translation: translation && translation.dialogs ? translation.dialogs.new_message : null
          });
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: classes.content
      }, /*#__PURE__*/React.createElement(CanSwitch, {
        role: role,
        coordinator: function coordinator() {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.addIcon
          }, /*#__PURE__*/React.createElement(AddCircleOutlineIcon, {
            className: classes.icon,
            color: "primary",
            onClick: function onClick() {
              console.log("addd user");
              handleModalDialogAddUser();
            }
          }));
        }
      }), /*#__PURE__*/React.createElement(CanSwitch, {
        role: role,
        coordinator: function coordinator() {
          return /*#__PURE__*/React.createElement(InputSearch, {
            value: searchValue,
            classes: classes.inputSearch,
            onChange: handleSearchChange,
            placeholder: translation ? translation.placeholders.search : "Search user"
          });
        }
      }), /*#__PURE__*/React.createElement(ContainerSearch, {
        search: searchValue,
        searchParam: "name",
        options: data.direct_messages,
        template: function template(option) {
          return /*#__PURE__*/React.createElement(CanSwitch, {
            role: role,
            coordinator: function coordinator() {
              return /*#__PURE__*/React.createElement(MobileCardItem, {
                template: "directMessageListStaffCoordinator",
                data: option,
                classes: classes.m12
              });
            },
            trainer: function trainer() {
              return /*#__PURE__*/React.createElement(MobileCardItem, {
                template: "directMessageList",
                data: option,
                classes: classes.m12
              });
            },
            parent: function parent() {
              return /*#__PURE__*/React.createElement(MobileCardItem, {
                template: "directMessageList",
                data: option,
                classes: classes.m12
              });
            }
          });
        },
        notFound: function notFound() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            classes: classes.defaultCard
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, translation && translation.groups ? translation.groups.search.not_found : "We didn't find any results"));
        },
        empty: function empty() {
          return /*#__PURE__*/React.createElement(MobileCardItem, {
            classes: classes.defaultCard
          }, /*#__PURE__*/React.createElement(Typography, {
            variant: "body1",
            align: "center"
          }, translation && translation.groups ? translation.groups.search.no_options : "There are no group created"));
        }
      })));
    }
  }));
};

export { MobileCampusDirectMessages };